import { Location } from '@angular/common';
import { Component, Inject, inject, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { User } from '../../services/user.js';
import { Auth } from '../../services/auth';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ViewUploadedFile } from '../../pages/common-features/view-uploaded-file/view-uploaded-file.js';

@Component({
  selector: 'app-my-drive',
  standalone: false,
  templateUrl: './my-drive.html',
  styleUrl: './my-drive.less'
})
export class MyDrive implements OnInit{
  private location = inject(Location);
  private userService = inject(User);
  private authService = inject(Auth);
  private matDialog = inject(MatDialog);
  entityName:string ='';
  entityId:any=''
  dataSource= new MatTableDataSource();
  user:any;
  displayedColumns :string[]=['name','docType','dateUploaded','action']
  constructor(
    private _dialog: MatDialogRef<MyDrive>,
    @Inject(MAT_DIALOG_DATA) public data:any,
  ){
    this.authService.user.subscribe((x:any)=>this.user = x);
   
  }

  ngOnInit(): void {
    this.entityName = this.data.entityName;
    this.entityId =  this.data.entityId;
    this.getMediaFiles();
  }

  close(){
    this._dialog.close();
  }

  getMediaFiles(){
    this.userService.getMediaFiles(this.entityName,this.entityId)
    .subscribe({
      next:(data:any)=>{
        this.dataSource.data = data;
      }
    })
  }


  viewMediaFile(row:any){
    console.log(row);
    let viewFileComponent = this.matDialog.open(ViewUploadedFile,{
      disableClose:true,
      height:'800px',
      width:'800px',
      data:row
    })
    viewFileComponent.afterClosed().subscribe(result=>{
      console.log(result);
    })
  }
  
  deleteMedia(id:any){
    this.userService.deleteMediaById(id)
    .subscribe({
      next:(data:any)=>{
        console.log(data);
        this.getMediaFiles();
      },error:(error:any)=>{
        console.log(error);
      }
    })
  }

  isInRole(privileges:string[]){
    const cc = this.user?.privileges?.filter((x:any) => privileges.includes(x));
    if(cc != undefined && cc?.length > 0){
        return true;
    }else{
        return false;
    }
    
}
disableIcon(){

}
 
}
